module.exports = __webpack_public_path__ + "static/img/console-empty.34be155e.png";